class APIS {
	apis() {
		return {
			fetchEVoting: {
				headers: {
					"xt-user-token": null,
				},
				method: "post",
				path: "/fetch/shareholder",
			},
			
			
		};
	}
}

export default new APIS();
